module.exports = __webpack_public_path__ + "img/10.dec88201.jpeg";